import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/home';
import Privacy from './pages/privacy';
import Admin from './pages/admin';

const Main = () => {
  return (
    <Routes>
      <Route exact path="/" element={<Home/>}/>
      <Route exact path="/privacy" element={<Privacy/>}/>
      <Route exact path="/admin" element={<Admin/>}/>
    </Routes>
  );
}

export default Main;